/**
 * LearnPageLayout Component
 *
 * The standard layout wrapper for all Learn pages.
 * Provides:
 * - Hero section at top
 * - Two-column layout (TOC sidebar + main content)
 * - Responsive: TOC hidden on mobile
 * - Auto-generated TOC from section IDs
 *
 * Usage:
 * <LearnPageLayout
 *   title="Learn Intervals"
 *   subtitle="Master the foundation of music"
 *   tocItems={[...]}
 * >
 *   <ContentSection id="intro">...</ContentSection>
 *   <ContentSection id="practice">...</ContentSection>
 * </LearnPageLayout>
 *
 * Used in: StartHere, Intervals, Chords, Progressions learn pages
 */

import React from "react";
import TableOfContents from "../TableOfContents";
import styles from "../../styles/learn/LearnPageLayout.module.css";
import "../../styles/shared/designSystem.css";

export interface TOCItem {
    id: string;
    label: string;
}

interface LearnPageLayoutProps {
    title: string;
    subtitle: string;
    tocItems: TOCItem[];
    children: React.ReactNode;
}

export default function LearnPageLayout({
    title,
    subtitle,
    tocItems,
    children,
}: LearnPageLayoutProps) {
    return (
        <div className={styles.learnPage}>
            {/* Hero Section */}
            <section className={styles.hero}>
                <h1 className={styles.heroTitle}>{title}</h1>
                <p className={styles.heroSubtitle}>{subtitle}</p>
            </section>

            {/* Main Layout: TOC + Content */}
            <div className={styles.contentWithToc}>
                <TableOfContents items={tocItems} />
                <main className={styles.mainContent}>{children}</main>
            </div>
        </div>
    );
}
